import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BlockWeighmentListing } from './Pages'

export const BlockWeighmentRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={BlockWeighmentListing} />
    </Fragment>
)